import React, {useContext, useState, useEffect} from "react"
import Media from "react-media"

// data and config
import data from "../../../../data"
import Util from "../../../../util"
import Config from "../../../../config"

// context
import {CatalogueContext} from "../../../../context"

// components & context providers
import {Actions, IncludedInPackages, Heading, Customize, WeatherAndSeason, Conditions, Benefits, Options, Regions, Texts, HomeDeliveryInfos, OnlineEventInfos, Videos} from "./index"
import {FavouriteToggle, Money, Overlay, Rating} from "../../../controls"
import {Block, HtmlHeader, RelatedActivities, Scaffolding, Sidebar, SidebarItem, Testimonials} from "../../../shared"
import ShoppingList from "../ShoppingList"
import ActivityNotFound from "./ActivityNotFound";
import ActivityInfo from "./ActivityInfo";
import {Redirect} from "react-router-dom"

// styling
import "./Activity.scss"

// the sidebar component
function ActivitySidebar({activity, onClickCustomize}) {
  return (
    <Sidebar className="activity">
      <SidebarItem title="Dein Warenkorb">
        <ShoppingList />
      </SidebarItem>
      <SidebarItem title={activity.title}>
        <Actions activity={activity} onClickCustomize={onClickCustomize} position="sidebar" />
      </SidebarItem>
      {/* 
      <SidebarItem title="Kundenmeinungen">
        <Testimonials mode="desktop" />
      </SidebarItem>
      */}
    </Sidebar>
  )
}

// the component
function Activity(props) {
  // context
  let catalogue = useContext(CatalogueContext)

  // get the slug (provided by react router)
  let slug = props.match.params.slug

  // state uses
  const [customizeOpen, setCustomizeOpen] = useState(false)
  const [activity, setActivity] = useState(null)
  const [redirectToCart, setRedirectToCart] = useState(false)
  const [redirectToSearch, setRedirectToSearch] = useState(false)

  // scroll to top when mounting
  useEffect(() => {
    Util.Scroll.scrollToTop()
  }, [slug])

  // process side effects
  useEffect(() => {
    if(catalogue.isReady) {
      // retrieve the activity
      let a = data.Catalogue.getActivityBySlug(slug)
      // and set the activity
      setActivity(a)
    }
  }, [slug, catalogue.isReady])
  
  // redirect to cart?
  if(redirectToCart) {
    return <Redirect to="/checkout" />
  }

  // redirect to search? 
  if(redirectToSearch) {
    return <Redirect to="/" />
  }

  // catalogue and other data still loading?
  // TODO why check that here again? we already check this in the useEffect above
  if(!catalogue.isReady) {
    return null
  }

  // no activity with that slug found?
  // TODO Style this
  if(activity === null) {
    return <ActivityNotFound />
  }
  
  // seo values for Helmet
  let seo_title = `${activity.title} - Appentura`
  let seo_image = (activity.images.find(i => i.default) || activity.images[0])
  
  // get the activity variant
  let activityVariant = null
  let adventureActivity = data.Cart.getAdventureActivity(activity._id) // activty already in cart?
  if(adventureActivity) {
    activityVariant = activity.regionVariants.find(rv => rv.regionCode === adventureActivity.RegionCode)
  }
  if(!activityVariant) {
    activityVariant = data.Activity.getDefaultVariant(activity)
  }

  // render
  return (
    <Media queries={{
      large: "(min-width: 640px)"
    }}>
      {matches => {
        let content = null
        let className = null
        if(matches.large) {
          content = <ActivityLarge activity={activity} activityVariant={activityVariant} setCustomizeOpen={setCustomizeOpen} setRedirectToSearch={setRedirectToSearch} />
          className = "large"
        }
        else {
          content = <ActivitySmall activity={activity} activityVariant={activityVariant} setCustomizeOpen={setCustomizeOpen} setRedirectToSearch={setRedirectToSearch} />
          className = "small"
        }
        return (
          <Scaffolding>
          <div id="v-activity" className={className}>
            <HtmlHeader title={seo_title} imageUrl={seo_image.url_thumbnail || seo_image.url || ''} />
            {content}
            <Overlay
              visible={customizeOpen}
              close={() => {
                setCustomizeOpen(false) 
              }}
              closeOnClickOutside={false}
              position = "fill"
            >
              <Customize 
                activity={activity} 
                cancel={() => {
                  setCustomizeOpen(false)
                }}
                close={() => {
                  setCustomizeOpen(false) // probably not needed, since we redirect
                  setRedirectToCart(true)
                }} 
              />
            </Overlay>
          </div>
          </Scaffolding>
        )
      }}
    </Media>
  )  
}

function ActivitySmall({activity, activityVariant, setCustomizeOpen, setRedirectToSearch}) {
  // the lowest price
  let minPrice = activity.__minPricePerPerson;

  // render
  return (
    <>
    <Heading activity={activity} size="small" />
    
    <div className="add-to-favourites"><FavouriteToggle activityId={activity._id} /></div>
    <div className="rating"><Rating activity={activity} textMode="averageAndCount" hideIfNoRating={true} centered /></div>
    <div className="price">pro Person ab {Config.currency} <Money amount={minPrice} showCurrency={false} useDash={true} /></div>
    
    <ActivityInfo size="small" />
    {/*<Stories activity={activity} /> */}
    
    
    <Block 
      sidebar={<ActivitySidebar activity={activity} onClickCustomize={() => {setCustomizeOpen(true)}} />}
      sidebarPosition="right"
      showConsoleInMain={false}
      console={<Actions activity={activity} onClickCustomize={() => {setCustomizeOpen(true)}} />}
      renderAfter={(mode) => mode === "mobile" ? <Testimonials mode="mobile" /> : null }
    >
      <div className="main boxshadow">
        <Texts activity={activity} showRating={false} />
        <Videos activity={activity} />
        <IncludedInPackages activity={activity} />
        <HomeDeliveryInfos activity={activity}  />
        <OnlineEventInfos activity={activity}  />
        <WeatherAndSeason activity={activity} activityVariant={activityVariant} />
        <Conditions activityVariant={activityVariant} />
        <Benefits activityVariant={activityVariant} />
        <Regions activity={activity} />
        <Options activity={activity} />
        <Actions activity={activity} onClickCustomize={() => {setCustomizeOpen(true)}} />
      </div>
      {/*}
      <div className="back-to-search">
        <Button kind="ok" onClick={() => setRedirectToSearch(true)}>Alle Erlebnisse anzeigen</Button>
      </div>
    */}
      <RelatedActivities activity={activity} title="Ähnliche Erlebnisse" />
    </Block>
    </>
  )
}

function ActivityLarge({activity, activityVariant, setCustomizeOpen, setRedirectToSearch}) {
  // some of the components we use need an activityVariant (either the adventureActiviy or the default region variant)
  //let activityVariant = data.Activity.getDefaultVariant(activity)
  // render
  return (
    <Block 
      sidebar={<ActivitySidebar activity={activity} onClickCustomize={() => {setCustomizeOpen(true)}} />}
      sidebarPosition="right"
      console={<Actions activity={activity} onClickCustomize={() => {setCustomizeOpen(true)}} />}
    >
      <div className="main boxshadow">
        <Heading activity={activity} size="large" onClickCustomize={() => setCustomizeOpen(true)} />
        {/* 
        <div className="divider" />
        <div className="rating"><Rating activity={activity} textMode="averageAndCount" hideIfNoRating={true} /></div>
        <Stories activity={activity} />
        <div className="divider" />
        */}
        <div className="details_new">
          <Videos activity={activity} />
          <IncludedInPackages activity={activity} />
          <HomeDeliveryInfos activity={activity}  />
          <OnlineEventInfos activity={activity} />
          <WeatherAndSeason activity={activity} activityVariant={activityVariant} />
          <Conditions activityVariant={activityVariant} />
          <Benefits activityVariant={activityVariant} />
          <Regions activity={activity} />
          <Options activity={activity} />
        </div>
        {/*}
        <div className="details_old">
          <HomeDeliveryInfos activity={activity}  />
          <OnlineEventInfos activity={activity} />
          <WeatherAndSeason activity={activity} activityVariant={activityVariant} />
          <Conditions activityVariant={activityVariant} />
          <Benefits activityVariant={activityVariant} />
          <Regions activity={activity} />
          <Options activity={activity} />
        </div>
        */}
        <div className="actions">
          <Actions activity={activity} onClickCustomize={() => {setCustomizeOpen(true)}} />
        </div>
      </div>
      {/*
      <div className="back-to-search">
        <Button kind="ok" onClick={() => setRedirectToSearch(true)}>Alle Erlebnisse anzeigen</Button>
      </div>
      */}
      
      <RelatedActivities activity={activity} title="Ähnliche Erlebnisse" />
      
    </Block>
  )
}

export default Activity
